import { render } from "./UpdateUser.vue?vue&type=template&id=2e537dcf&scoped=true"
import script from "./UpdateUser.vue?vue&type=script&lang=js"
export * from "./UpdateUser.vue?vue&type=script&lang=js"

import "./UpdateUser.vue?vue&type=style&index=0&id=2e537dcf&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2e537dcf"

export default script